var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 3.8c-.8 0-1.5.6-1.5 1.5s.6 1.5 1.5 1.5 1.5-.6 1.5-1.5c.2-.9-.6-1.5-1.5-1.5zM3.9 16.2h2.6V8H3.9v8.2zm9.3-8.6s-2-.1-2.6 1.4V8H8.1v8.2h2.6v-4.5c0-.1 0-1.8 1.6-1.8 1.4 0 1.4 2 1.4 2v4.2h2.5v-4.9c-.1.2.3-3.6-3-3.6z"
  })));
};
export default SvgSocialLinkedin;